<form class="form-container" [formGroup]="form">
  <h3>Campanhas</h3>

  <p-panel header="Conteúdo da campanha">
    <div class="form-field">
      <label
        >Título (obrigatório, máximo {{ titleMaxLength }} caracteres)</label
      >
      <input
        type="text"
        pInputText
        formControlName="title"
        [ngClass]="{ error: isControlInvalid('title') }"
      />
      <p class="error-message" *ngIf="isControlInvalid('title')">
        Título é obrigatório e deve respeitar o limite máximo.
      </p>
    </div>

    <div class="form-field glampoints-fields">
      <div>
        <label>Glampoints mínimo (obrigatório)</label>
        <p-inputNumber
          formControlName="minimumGlampoints"
          mode="decimal"
          [min]="0"
          [step]="0.01"
          [maxFractionDigits]="2"
          [ngClass]="{ error: isControlInvalid('minimumGlampoints') }"
        ></p-inputNumber>
      </div>

      <div>
        <label>Glampoints máximo (obrigatório)</label>
        <p-inputNumber
          formControlName="maximumGlampoints"
          mode="decimal"
          [min]="0"
          [step]="0.01"
          [maxFractionDigits]="2"
          [ngClass]="{ error: isControlInvalid('maximumGlampoints') }"
        ></p-inputNumber>
      </div>
    </div>
    <p class="error-message" *ngIf="isControlInvalid('minimumGlampoints')">
      O glampoints mínimo é obrigatório.
    </p>
    <p class="error-message" *ngIf="isControlInvalid('maximumGlampoints')">
      O glampoints máximo é obrigatório.
    </p>
    <p class="error-message" *ngIf="isGlampointsRangeInvalid()">
      O valor mínimo de glampoints não pode ser maior que o máximo.
    </p>

    <div class="form-field">
      <label>
        Descrição (obrigatório, máximo {{ descriptionMaxLength }} caracteres)
      </label>
      <textarea
        pInputTextarea
        rows="5"
        formControlName="description"
        [ngClass]="{ error: isControlInvalid('description') }"
      ></textarea>
      <p class="error-message" *ngIf="isControlInvalid('description')">
        Descrição é obrigatória e deve respeitar o limite máximo.
      </p>
    </div>

    <div class="form-field">
      <label>Como funciona</label>
      <input type="text" pInputText value="Como funciona" readonly />
      <small>Esse texto é fixo no frontend e não pode ser alterado aqui.</small>
    </div>

    <div class="form-field" formArrayName="steps">
      <label>Passos (obrigatório)</label>

      <div
        class="steps-list"
        *ngFor="let stepControl of steps.controls; let i = index"
      >
        <div class="steps-list__header">
          <span>Passo {{ i + 1 }}</span>
          <p-button
            type="button"
            label="Remover"
            severity="danger"
            [outlined]="true"
            (onClick)="removeStep(i)"
          ></p-button>
        </div>
        <textarea
          pInputTextarea
          rows="3"
          [formControlName]="i"
          [ngClass]="{ error: isStepInvalid(i) }"
        ></textarea>
        <p class="error-message" *ngIf="isStepInvalid(i)">
          O texto do passo é obrigatório.
        </p>
      </div>

      <p-button
        type="button"
        label="Adicionar passo"
        [outlined]="true"
        (onClick)="addStep()"
      ></p-button>
    </div>

    <div class="form-field">
      <label># para copiar (obrigatório)</label>
      <input
        type="text"
        pInputText
        formControlName="hashtagCode"
        [ngClass]="{ error: isControlInvalid('hashtagCode') }"
      />
      <p class="error-message" *ngIf="isControlInvalid('hashtagCode')">
        O campo de hashtag é obrigatório.
      </p>
    </div>

    <div class="form-field">
      <label>Imagem - WEBP | Dimensão 768x418 (obrigatório)</label>
      <p-fileUpload
        mode="basic"
        chooseLabel="upload"
        name="demo[]"
        [auto]="true"
        accept="image/webp"
        [maxFileSize]="250 * 1024"
        (onSelect)="
          handleFileSelect($event, 'image', 768, 418, 250 * 1024, image)
        "
        [showUploadButton]="false"
        [showCancelButton]="false"
        #image
        styleClass="p-button-raised p-button-secondary"
      ></p-fileUpload>
      <p class="error-message" *ngIf="isControlInvalid('image')">
        A imagem da campanha é obrigatória.
      </p>
    </div>

    <div class="form-container__img">
      <img *ngIf="campaignImageUrl" [src]="campaignImageUrl" />
    </div>

    <div class="form-actions">
      <p-button
        [outlined]="true"
        styleClass="cancel-button"
        label="Cancelar"
        (onClick)="goToMenu()"
      ></p-button>
      <p-button
        styleClass="p-button"
        label="Salvar"
        (onClick)="save()"
        [disabled]="form.invalid || isGlampointsRangeInvalid()"
      ></p-button>
    </div>
  </p-panel>
</form>
